import HolidayComp from '../components/Holiday'

const Holiday = () => {
  return (
    <>   
    <HolidayComp/>
    </>
  )
}

export default Holiday